module.exports = "<div class=\"col-sm-12\">\r\n  <h5 class=\"mb-3\"><strong>Today's Insight</strong></h5>\r\n</div>\r\n<div *ngIf=\"isAdmin;then admin else super_admin\">here is ignored</div>    \r\n<ng-template #admin><app-dashboard-admin></app-dashboard-admin></ng-template>\r\n<ng-template #super_admin><app-dashboard-superadmin></app-dashboard-superadmin></ng-template>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/dashboard-main.component.html
// module id = ../../../../../src/app/logistics-operations/dashboard-main/dashboard-main.component.html
// module chunks = main